import { useTranslation } from 'react-i18next';

import { StyledTabs, StyledTab } from './Tabs.style';

const Tabs = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const tabs = [t('flightstatus.search.tab.1'), t('flightstatus.search.tab.2')];

  const handleChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <StyledTabs
      defaultValue={activeTab}
      value={activeTab}
      onChange={handleChange}
    >
      {tabs.map((tab) => (
        <StyledTab key={tab} label={tab} />
      ))}
    </StyledTabs>
  );
};

export default Tabs;
